import React from "react"
import { dummyArticles, dummyTitle } from "../dummy";
import commonMethod from "../lib/commonMethod";
import ConfirmBtn from './ConfirmBtn';
import SearchItemTop from './SearchItemTop';
import Colors from "./Colors";
import TableTr from "./TableTr";
import ColumnResizer from 'column-resizer';
import { replaceThumbnails } from "../thumbnail"
import ReactDOM from 'react-dom';
import $ from 'jquery';


class Organisms extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedKeyword: [],
            list: [],
            loading: true,
            severError: false
        }
        this.tableSelector = '#testTable';
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate() {
        // this.resize();
    }

    keywordsHandle(articles) {
        let keywordsArry = [];

        articles.map((v) => {
            v.keywords.map((v2, i) => {
                if (i < 5) {
                    keywordsArry.push(v2);
                }
            });
        });

        let set = new Set(keywordsArry);
        let keywords = [...set];
        keywords = keywords.filter(v => v !== '');
        return Colors({ list: keywords, type: 'Keywords' });
    }

    isKeyInObject(articles, key) {
        let names = [];
        articles.map((v) => {
            let indexs = v.science_index.split(';');
            indexs.map((v2, i) => {
                if (i < 5) {
                    names.push(v2);
                }
            });
        });

        names = names.filter((v) => v != '');
        return names;
    }

    confirm() {

        if (this.state.selectedKeyword.length !== 0) {
            this.props.addSearchKeyword(this.state.selectedKeyword);
        }
    }

    resize() {
        const options = {
            resizeMode: 'fit',
            liveDrag: true,
            headerOnly: true,
            disabledColumns: [3],
            widths: [100, 193, 287, 332, 50],
        };
        if (!this.resizer) {

            this.resizer = new ColumnResizer(ReactDOM.findDOMNode(this).querySelector(`${this.tableSelector}`), options);
        } else {
            this.resizer.reset(options)
        }

    }

    getData() {
        const { data, searchList } = this.props;
        let parameter = commonMethod.makeParameter(this.props.userId, this.props.accessToken, data.code, searchList);
        let keywords = parameter.data_set.data_input.data.replace(/,/g, ' ');

        let keywordData = {
            data: keywords
        };


        $.ajax({
            url: 'https://rrvsxm3yy3.execute-api.us-west-1.amazonaws.com/prod/search',
            data: JSON.stringify(keywordData),
            contentType: 'application/json',
            dataType: 'json',
            type: 'post',
        }).then((res) => {
            if (res) {
                if (res.errorMessage) {
                    this.setState({ list: [], loading: false })
                } else {
                    this.setState({ list: res.body, loading: false, severError: false });
                }
            } else {
                this.setState({ list: [], loading: false, severError: true });
            }
            this.resize();
        }).catch((XMLHttpRequest, textStatus, errorThrown) => {
            // console.log(XMLHttpRequest, textStatus, errorThrown)

            if (textStatus) {
                this.setState({ loading: false, severError: true })
            }
        })




    }

    tHeader() {
        let titles = dummyTitle, tHeadTh;

        tHeadTh = titles.map((v, i) => {
            return <th key={i}>{v}</th>;
        });

        return tHeadTh
    }

    toggleKeyword(e, data, keywords, scienceIndex) {
        if (e.target.tagName == "A") return false;

        let condition = this.props.data.condition

        if (condition === "editing" || condition === "editable") {
            let selectedKeyword = this.state.selectedKeyword;
            let idx = selectedKeyword.findIndex(keyword => keyword.id === data.idx);
            if (idx > -1) {
                selectedKeyword.splice(idx, 1);
            } else {
                let keywordObj = {
                    id: data.idx,
                    code: this.props.data.code,
                    title: data.cname,
                    keyword: keywords,
                    scienceIndex,
                    keywordDetail: {
                        ...data
                    }
                }
                data.keywordAll = keywords;
                data.scienceIndex = scienceIndex;
                selectedKeyword.push(keywordObj);
            }

            this.setState({ selectedKeyword: selectedKeyword })

            this.props.editItem(this.props.data, selectedKeyword, keywords, this.props.type, scienceIndex);
        }

    }

    render() {
        let data = this.props.data;
        let keywordList = this.state.keywordList;
        let list = this.state.list;

        return <div id={data.id} className={data.condition === "waiting" ?
            "search-item-wrap paper-keyword movable organisms" : "search-item-wrap paper-keyword organisms"}>
            <SearchItemTop addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                data={this.props.data} isOpen={this.state.isOpen} keywordList={this.state.selectedKeyword}
                setIsOpen={(isOpen) => this.setState({ isOpen: isOpen })}
                deleteItem={() => this.props.deleteItem()}
                libraryList={this.props.libraryList} />

            {(this.state.isOpen || data.condition === "editing") &&
                <React.Fragment>
                    {!this.state.loading && (list && list.length !== 0) && <p className="total-count">Total : {list.length}</p>}
                    {!this.state.loading ?
                        !this.state.severError ? (list && list.length !== 0) ?
                            <table id="testTable" className="list">
                                <thead id="resultThead">
                                    <tr>{this.tHeader()}</tr>
                                </thead>
                                <tbody id="resultTbody">
                                    {list.map((v, i) => {
                                        v.idx = i;
                                        return <TableTr
                                            key={i}
                                            idx={i}
                                            trData={v}
                                            titles={dummyTitle}
                                            toggleKeyword={(e, data, keywords, scienceIndex) => this.toggleKeyword(e, data, keywords, scienceIndex)}
                                            selectedKeyword={this.state.selectedKeyword}
                                        />
                                    })}
                                </tbody>
                            </table> : <p className="no_result_text">No search results found.</p> : <p className="no_result_text">Server is busy. Please try again.</p>
                        : <p className="no_result_text">It may take 10 seconds</p>}

                    {(data.condition !== "complete" && data.condition !== "editable") &&
                        <ConfirmBtn isConfirm={this.props.beforeItem ? this.props.beforeItem.keyword.length !== 0 && this.state.selectedKeyword.length !== 0 : this.state.selectedKeyword.length !== 0}
                            onClick={() => this.confirm()} />
                    }

                </React.Fragment>
            }
        </div>
    }
}


export default Organisms